// Utils
import initialInputs from './initial-inputs';

const LENGTH_OF_YEAR = 365;
const LENGTH_OF_MONTH = 30.42;
const LENGTH_OF_DAY = 1;

function translatePeriod(input = 'monthly') {
  switch (input) {
    case 'daily':
      return LENGTH_OF_DAY;
    case 'monthly':
      return LENGTH_OF_MONTH;
    case 'annually':
      return LENGTH_OF_YEAR;
    default:
      return LENGTH_OF_MONTH;
  }
}

function compoundInterest(inputs = { ...initialInputs }) {
  const investmentTimespan = Math.min(inputs.investment_timespan, 50);

  const contributionPeriod = translatePeriod(inputs.contribution_period);
  const compoundingPeriod = translatePeriod(inputs.compounding_period);
  const contributionAmount = inputs.contribution_amount;
  let currentPrincipal = inputs.initial_principal;
  const interestRate =
    inputs.percent_return * (compoundingPeriod / LENGTH_OF_YEAR);

  const result = [['Interest'], ['Principal']];
  let interestSum = 0;

  for (let i = 0; i < investmentTimespan * LENGTH_OF_YEAR; i += 1) {
    if (Math.floor(i % contributionPeriod) === 0) {
      currentPrincipal += contributionAmount;
    }

    if (Math.floor(i % compoundingPeriod) === 0) {
      interestSum += (currentPrincipal + interestSum) * interestRate;
    }

    // Only record every 365 days, and after the first 365
    if (Math.floor((i + 1) % LENGTH_OF_YEAR) === 0) {
      result[0].push(Math.ceil(interestSum));
      result[1].push(Math.ceil(currentPrincipal));
    }
  }
  return result;
}

export default (
  state = {
    defaults: initialInputs,
    resolvedInputs: {},
    inputs: {},
    validInputs: true,
    outputs: {},
  },
  { name, value } = {}
) => {
  const newState = JSON.parse(JSON.stringify(state));

  if (name) {
    newState.inputs[name] = value;
  }

  newState.resolvedInputs = {
    ...newState.defaults,
    ...newState.resolvedInputs,
    ...newState.inputs,
  };

  newState.inputAccepted = true;

  // Set whether the inputs are valid.
  newState.validInputs = newState.resolvedInputs;
  newState.outputs = compoundInterest(newState.resolvedInputs);

  return newState;
};
